<div class="cv-view-panorama-tour photo-gallery-component">
    <div cvJsfDisposableSection [data]="directiveData">
        <div class="photo-gallery-container flex-container">
            <div class="photo-gallery-wrapper flex-container flex-column">

				<div *ngIf="isEditable" class="blur-tool-button-container">
					<button class="btn btn-sm cv-btn-light create-snapshot-btn smarttag-image"
							(click)="openBlurModal()">
						<i class="fas fa-pen-paintbrush" cvTooltip [tooltipText]="'Blur Tool'"
						   [tooltipPlacement]="'top'"></i>
					</button>
				</div>

                <div class="flex-container flex-justify-end buttons-wrapper"
                    *ngIf="isEditable">
                    <div>
                        <button class="btn btn-sm cv-btn-light create-snapshot-btn smarttag-image"
                                (click)="createSnapshot(captureType.SMARTTAG)">
                            <i class="fas fa-tag" cvTooltip [tooltipText]="'SmartTag'"
                               [tooltipPlacement]="'top'"></i>
                        </button>
                    </div>
                    <div>
                        <button class="btn btn-sm cv-btn-light create-snapshot-btn report-image"
                                (click)="createSnapshot(captureType.REPORT)">
                            <i class="fas fa-file-image" cvTooltip [tooltipText]="'Report Image'"
                               [tooltipPlacement]="'top'"></i>
                        </button>
                    </div>
                </div>

                <div class="flex-container arrows-wrapper" [ngClass]="{'hidden-arrows': reportImage.snapshot !== null}">
                    <div class="arrow-left-wrapper">
                        <div (click)="previousPanorama()" aria-hidden="true"
                             class="ngx-gallery-icon ngx-gallery-arrow arrow-left"
                             [ngClass]="{'disable-arrow': !this.album || (this.album && this.album.length <= 1)}">
                            <i class="ngx-gallery-icon-content fas fa-chevron-left"></i>
                        </div>
                    </div>
                    <div>
                        <div (click)="nextPanorama()" aria-hidden="true"
                             class="ngx-gallery-icon ngx-gallery-arrow arrow-right"
                             [ngClass]="{'disable-arrow': !this.album || (this.album && this.album.length <= 1)}">
                            <i class="ngx-gallery-icon-content fas fa-chevron-right"></i>
                        </div>
                    </div>
                </div>

                <div class="photo-wrapper">
                    <div class="photo-container" [ngClass]="{'disabled-controls': reportImage.disabledControls}">
                        <div class="render-loader">
                            <div class="card skeleton">
                                <div class="card-body">
                                    <div class="row">
                                        <div class="col-md-2">
                                            <h5 class="card-title loading">&nbsp;</h5>
                                        </div>
                                    </div>
                                    <div class="card-img card-img-bottom loading">
                                        <div class="loader-icon">
                                            <i class="fas fa-images"></i>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div class="render-content">

                        </div>
                    </div>
                    <div class="paginator flex-container">
                        <div class="section-pag-name">
                            {{title}}
                        </div>
                        <div>
                            <i class="fas fa-image"></i>
                            {{ currentIndexAlbumSelected + 1}}
                            / {{album.length}}
                        </div>
                    </div>
                </div>

            </div>
            <!--<div class="captured-report-image" [ngClass]="{'no-image-captured': reportImage.snapshot === null}">

            </div>-->
        </div>
    </div>
    <!-- Placeholder that contains the on fly image -->
    <div class="fake-scene-render" style="display: none;"></div>
</div>
